export default "__VITE_ASSET__BK2Fx2Q7__"